const platformConfig = {
  home: [
    {
      name: 'apple',
      link: 'https://apps.apple.com/us/app/x-poker-poker-with-friends/id1534470447',
      target: '_self',
      mIcon: require('@/assets/images/home/mobile/home_apple.png'),
      pcIcon: require('@/assets/images/home/pc/home_apple.png')
    },
    // {
    //   name: 'google',
    //   link: 'https://play.google.com/store/apps/details?id=com.game.android.xpoker',
    //   target: '_blank',
    //   mIcon: require('@/assets/images/home/mobile/home_google.png'),
    //   pcIcon: require('@/assets/images/home/pc/home_google.png')
    // },
    {
      name: 'android',
      link: 'https://static.x-game.net/version/website/X-Poker1.12.55.1.apk?t=1727597506',
      linkList: [
        'https://static.x-game.net/version/website/X-Poker1.12.55.1.apk?t=1727597506',
        'https://static.littleponyygames.com/version/website/X-Poker1.12.55.1.apk?t=1727597506',
        'https://static.x-poker.ru/version/website/X-Poker1.12.55.1.apk?t=1727597506',
        'https://static.mycodeclasses.com/version/website/X-Poker1.12.55.1.apk?t=1727597506',
        'https://static.littleponygames.ru/version/website/X-Poker1.12.55.1.apk?t=1727597506'
      ],
      target: '_blank',
      mIcon: require('@/assets/images/home/mobile/home_android.png'),
      pcIcon: require('@/assets/images/home/pc/home_android.png')
    },
    {
      name: 'windows',
      link: 'https://static.x-game.net/version/website/X-Poker9.0.msi?t=1702934641',
      linkList: [
        'https://static.x-game.net/version/website/X-Poker9.0.msi?t=1702934641',
        'https://static.littleponyygames.com/version/website/X-Poker9.0.msi?t=1702934641',
        'https://static.x-poker.ru/version/website/X-Poker9.0.msi?t=1702934641',
        'https://static.mycodeclasses.com/version/website/X-Poker9.0.msi?t=1702934641',
        'https://static.littleponygames.ru/version/website/X-Poker9.0.msi?t=1702934641'
      ],
      target: '_blank',
      mIcon: require('@/assets/images/home/mobile/home_pc.png'),
      pcIcon: require('@/assets/images/home/pc/home_pc.png')
    }
  ],
  kr: {
    home: [
      {
        name: 'apple',
        link: 'https://testflight.apple.com/join/piY9ouNr',
        target: '_blank',
        mIcon: require('@/assets/images/home/mobile/home_apple.png'),
        pcIcon: require('@/assets/images/home/pc/home_apple.png')
      },
      {
        name: 'android',
        link: 'https://static.x-game.net/version/website/X-Poker1.12.55.1.apk?t=1727597506',
        linkList: [
          'https://static.x-game.net/version/website/X-Poker1.12.55.1.apk?t=1727597506',
          'https://static.littleponyygames.com/version/website/X-Poker1.12.55.1.apk?t=1727597506',
          'https://static.x-poker.ru/version/website/X-Poker1.12.55.1.apk?t=1727597506',
          'https://static.mycodeclasses.com/version/website/X-Poker1.12.55.1.apk?t=1727597506',
          'https://static.littleponygames.ru/version/website/X-Poker1.12.55.1.apk?t=1727597506'
        ],
        target: '_blank',
        mIcon: require('@/assets/images/home/mobile/home_android.png'),
        pcIcon: require('@/assets/images/home/pc/home_android.png')
      },
      {
        name: 'windows',
        link: 'https://static.x-game.net/X-Poker9.0.msi?t=1702934641',
        linkList: [
          'https://static.x-game.net/version/website/X-Poker9.0.msi?t=1702934641',
          'https://static.littleponyygames.com/version/website/X-Poker9.0.msi?t=1702934641',
          'https://static.x-poker.ru/version/website/X-Poker9.0.msi?t=1702934641',
          'https://static.mycodeclasses.com/version/website/X-Poker9.0.msi?t=1702934641',
          'https://static.littleponygames.ru/version/website/X-Poker9.0.msi?t=1702934641'
        ],
        target: '_blank',
        mIcon: require('@/assets/images/home/mobile/home_pc.png'),
        pcIcon: require('@/assets/images/home/pc/home_pc.png')
      }
    ]
  }
}
export default platformConfig



// WEBPACK FOOTER //
// ./src/util/platform.js